module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('integrations')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20966f44"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabIntegrations.vue
// module id = 2256
// module chunks = 0